import React from 'react';
import { Paper, Flex, Box, Icon, Heading, useMediaQuery } from '@mediahuis/chameleon-react';
import styled from 'styled-components';
import { ChevronForward } from '@mediahuis/chameleon-theme-wl/icons';
import ChatInfo from './ChatInfo';
import PhoneInfo from './PhoneInfo';
import EmailInfo from './EmailInfo';
var Container = styled(Paper).withConfig({
  displayName: "Footer__Container",
  componentId: "sc-18v8ipw-0"
})(["width:320px;display:flex !important;justify-content:space-between;align-items:center;@media (max-width:767px){width:100%;&:not(:last-child){margin-bottom:16px;}}&:first-child{border-top:1px solid #eee;}&:hover{cursor:pointer;}.boldCustomerServiceLink{font-weight:bold;}&:hover .boldCustomerServiceLink{text-decoration:underline;}"]);

var Footer = function Footer(_ref) {
  var chat = _ref.chat,
      email = _ref.email,
      phone = _ref.phone,
      title = _ref.title,
      openChat = _ref.openChat,
      openPhone = _ref.openPhone;
  var flexDirection = useMediaQuery({
    md: 'row'
  }, 'column');
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    mb: 4
  }, title && /*#__PURE__*/React.createElement(Heading, {
    level: 4,
    fontWeight: "regular"
  }, title)), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between",
    alignContent: "center",
    flexDirection: flexDirection
  }, chat.mayShow && /*#__PURE__*/React.createElement(Container, {
    onClick: openChat
  }, /*#__PURE__*/React.createElement(Box, {
    p: 4,
    width: "full"
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(ChatInfo, {
    componentData: chat
  }), /*#__PURE__*/React.createElement(Icon, {
    as: ChevronForward
  })))), phone.mayShow && /*#__PURE__*/React.createElement(Container, {
    onClick: openPhone
  }, /*#__PURE__*/React.createElement(Box, {
    p: 4,
    width: "full"
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(PhoneInfo, {
    componentData: phone
  }), /*#__PURE__*/React.createElement(Icon, {
    as: ChevronForward
  })))), email.mayShow && /*#__PURE__*/React.createElement(Container, {
    onClick: function onClick() {
      return window.open(email.link);
    }
  }, /*#__PURE__*/React.createElement(Box, {
    p: 4,
    width: "full"
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(EmailInfo, {
    componentData: email
  }), /*#__PURE__*/React.createElement(Icon, {
    as: ChevronForward
  }))))));
};

export default Footer;